<div class="box card-box">
  <div class="box-header">
    <h3>
      {{ descriptor?.transId | translate }}
    </h3>
  </div>
  <div class="box-body">
    <ul class="timeline timeline-center">
      <!--<li class="tl-header">-->
      <!--<div class="btn white active">Center me</div>-->
      <!--</li>-->
      <li class="tl-item" *ngFor="let event of data; let i = index"
          [class.tl-left]="i % 2 === 0">
        <div class="tl-wrap b-primary" *ngIf="event.values.EventDate.value">
          <span class="tl-date text-muted">{{event.values.EventDate.value | gpDate}}</span>
          <div class="tl-content box-color text-color">
            <span class="arrow b-white pull-top" [ngClass]="i % 2 !== 0 ? 'left' : 'right'"></span>
            <div class="text-lt p-x m-b-sm">
              <h3 class="ellipsis">{{event.values.Event.transId | translate}}</h3>
            </div>
            <div class="p-a b-t b-light white ellipsis">{{event.values.EventComment.value}}</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
